import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';
import globeUrl from '#src/app/pages/homepage/shared/assets/background-globe-sunrise.svg';
import {
	SapIssueForm,
	Tagline,
	TopImpactStoriesDesktop,
	TopImpactStoriesMobile,
	TopImpactStoriesMobileProvider,
} from '#src/app/pages/homepage/shared/components';

export const HeroSection: React.FC = () => {
	const {
		data: { topImpactStories },
	} = useHomepagePageData();

	return (
		<section
			data-testid="homepage-hero-section"
			className="text-typography-strong from-fill-information-weaker/0 via-fill-information-weaker/80 to-fill-information-weaker/0 relative overflow-hidden bg-linear-to-b"
		>
			<div
				aria-hidden="true"
				className="absolute aspect-video w-full max-w-[931px] translate-x-0 -translate-y-[20%] overflow-visible max-md:h-full md:top-[15%] md:left-1/2 md:-translate-x-1/2 md:-translate-y-[30%]"
			>
				{/* The old <img> combined object-cover with overflow-visible, letting the full
				    931x909 globe paint outside its 16:9 box. A div's mask cannot paint outside
				    its own box, so the cover-with-overflow rendering is reproduced by an inner
				    element at the SVG's aspect ratio spanning at least the outer box. */}
				<div
					className="bg-fill-information-weaker absolute top-1/2 left-1/2 aspect-[931/909] min-h-full min-w-full -translate-x-1/2 -translate-y-1/2"
					style={{
						maskImage: `url(${globeUrl})`,
						WebkitMaskImage: `url(${globeUrl})`,
						maskSize: 'cover',
						WebkitMaskSize: 'cover',
						maskRepeat: 'no-repeat',
						WebkitMaskRepeat: 'no-repeat',
						maskPosition: 'center',
						WebkitMaskPosition: 'center',
					}}
				/>
			</div>
			{/* eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname */}
			<div className="relative z-10 container pt-6 md:pt-11 lg:pt-[60px]">
				<div>
					<Text data-testid="homepage-hero-heading" variant="display" as="h1" className="m-0 text-center">
						<TranslateHtml value="corgi.homepage.hero_sunrise.title" />
						<span className="text-typography-brand dark:text-icon-brand">.</span>
					</Text>
					<Text data-qa="homepage-hero-subheading" variant="body" as="h2" className="mt-2 mb-8 text-center lg:mb-10">
						<Translate value="corgi.homepage.hero_section.subheading" />
					</Text>
					<SapIssueForm />
					<Tagline />
				</div>

				{topImpactStories.length > 0 && <TopImpactStoriesDesktop layout="row" />}
			</div>
			{topImpactStories.length > 0 && (
				<TopImpactStoriesMobileProvider>
					<TopImpactStoriesMobile />
				</TopImpactStoriesMobileProvider>
			)}
		</section>
	);
};
